// CANONICAL COPY (GH #7115). src/constants/obligations/obl-data-leakage-prevention.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-data-leakage-prevention',
  title: 'Verify data leakage prevention (DLP) measures',
  description:
    'Confirm that measures to prevent unauthorised disclosure of sensitive information are applied to systems, networks and any other devices that process, store or transmit sensitive information. Deploy and maintain a data loss prevention (DLP) solution covering at least endpoint, email and network egress channels; tune policies to the data classification scheme and review alerts on a defined cadence.',
  category: 'technical',
  scfIds: ['SCF-DAT-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'DLP policy or operating procedure is published' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
